import { ThemeProvider, useTheme } from '@mui/material';
import React, { useMemo } from 'react';

import { FinalContainer } from '../../components/FinalGrid/FinalGrid';
import { createTheme as createFooterTheme } from '../../themes/sde/footer';
import { createTheme as createFooterDarkTheme } from '../../themes/sde/footerDark';
import type { Theme } from '../../themes/themes';

interface FooterProps {
  id?: string;
  children: React.ReactNode;
}

export const Footer: React.FC<FooterProps> = ({ children, ...props }: FooterProps) => {
  const theme = useTheme<Theme>();

  const footerTheme = useMemo(() => {
    if (theme.palette.mode === 'dark') {
      return createFooterDarkTheme();
    }
    return createFooterTheme();
  }, [theme.palette.mode, createFooterTheme, createFooterDarkTheme]);

  return (
    <FinalContainer
      disableGutters
      component="footer"
      {...props}
      sx={{
        backgroundColor: footerTheme.palette.background.default,
        color: footerTheme.palette.text.primary,
      }}
    >
      <ThemeProvider theme={footerTheme}>{children}</ThemeProvider>
    </FinalContainer>
  );
};
